export enum TypeService {
  URL = 1,
  DOCUMENT = 2,
}
